import React, { useState } from "react";
import { Info, X } from "@phosphor-icons/react";

/**
 * "Was sehe ich hier?"-Button: klein, dezent, öffnet ein Popover mit
 * einem Titel + kurzem Erklär-Text. Inline auf Dashboard-Sektionen einsetzbar.
 */
export default function InfoHint({ title, text, testid, placement = "right" }) {
  const [open, setOpen] = useState(false);
  return (
    <span className="relative inline-flex" data-testid={testid}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-1 text-[11px] font-mono uppercase tracking-wider text-zinc-400 hover:text-[#00FA9A] transition-colors"
        data-testid={`${testid}-btn`}
      >
        <Info size={14} weight="regular" />
        Was sehe ich hier?
      </button>
      {open && (
        <div
          className="absolute z-30 top-full mt-2 w-72 sm:w-80 eid-card p-3 shadow-lg"
          style={{ [placement === "right" ? "right" : "left"]: 0 }}
          data-testid={`${testid}-popover`}
        >
          <div className="flex items-start justify-between gap-2">
            <div className="flex-1">
              <div className="eid-label mb-1">Kurz erklärt</div>
              <div className="text-sm font-medium text-white">{title}</div>
            </div>
            <button
              onClick={() => setOpen(false)}
              className="text-zinc-500 hover:text-white shrink-0"
              aria-label="Schließen"
            >
              <X size={14} />
            </button>
          </div>
          <p className="text-sm text-zinc-400 mt-2 leading-relaxed">{text}</p>
        </div>
      )}
    </span>
  );
}
